import React, { useEffect, useRef } from 'react';
import { FaSearch, FaTimes } from 'react-icons/fa';

/**
 * "Hazır süreler" başlık satırı + açılır arama.
 * Sağdaki mercek'e basınca sola doğru zarifçe genişleyen bir arama alanı açılır;
 * yazdıkça dışarıya (onChange) sorguyu iletir. Boşaltma/Escape ile kapanır.
 * value/onChange ile kontrol edilir (controlled).
 */
function PresetArama({ value, onChange, acik, onAcikChange }) {
  const inputRef = useRef(null);

  // Açılınca odağı arama alanına ver.
  useEffect(() => {
    if (acik && inputRef.current) inputRef.current.focus();
  }, [acik]);

  const kapat = () => { onAcikChange(false); onChange(''); };
  const toggle = () => { if (acik) kapat(); else onAcikChange(true); };

  return (
    <div className="mb-2 flex items-center">
      <label className="app-label !mb-0 flex-none">Hazır süreler</label>

      {/* Mercek aç/kapa düğmesi — etikete yapışık */}
      <button
        type="button"
        onClick={toggle}
        className={`ml-1.5 flex h-7 w-7 flex-none items-center justify-center rounded-full transition-all duration-200 ${
          acik
            ? 'bg-amber-100 text-amber-700 ring-1 ring-inset ring-amber-300'
            : 'text-slate-400 hover:bg-slate-100 hover:text-amber-600'
        }`}
        title={acik ? 'Aramayı kapat' : 'Hazır süreler içinde ara'}
        aria-label={acik ? 'Aramayı kapat' : 'Hazır süreler içinde ara'}
        aria-expanded={acik}
      >
        {acik ? <FaTimes className="h-3 w-3" /> : <FaSearch className="h-3.5 w-3.5" />}
      </button>

      {/* Sağa doğru genişleyen arama alanı (kapalıyken w-0, görünmez) */}
      <div
        className={`flex items-center overflow-hidden transition-all duration-300 ease-out ${
          acik ? 'ml-1.5 w-40 opacity-100 sm:w-56' : 'w-0 opacity-0'
        }`}
      >
        <div className="flex w-full items-center rounded-full border border-slate-300 bg-white pl-3 pr-1.5 shadow-sm transition-colors focus-within:border-amber-500 focus-within:ring-2 focus-within:ring-amber-500/20">
          <FaSearch className="h-3 w-3 flex-none text-slate-400" />
          <input
            ref={inputRef}
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Escape') kapat(); }}
            placeholder="Süre ara…"
            className="min-w-0 flex-1 bg-transparent py-1.5 pl-2 text-xs text-slate-700 outline-none placeholder:text-slate-300"
            aria-label="Hazır süreler içinde ara"
          />
          {value ? (
            <button
              type="button"
              onClick={() => { onChange(''); inputRef.current?.focus(); }}
              className="flex h-4 w-4 flex-none items-center justify-center rounded-full text-slate-300 transition-colors hover:bg-slate-100 hover:text-slate-500"
              aria-label="Aramayı temizle"
            >
              <FaTimes className="h-2.5 w-2.5" />
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default PresetArama;
